import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import * as UAParser from "ua-parser-js";
import Logo from './icons/Logo';

const menuItems = [
  {
    hash: 'hifi',
    title: 'MOOV 24 bit'
  },
  {
    hash: 'celebrities',
    title: '音樂人導賞'
  },
  {
    hash: 'genres',
    title: '分類導航'
  },
  {
    hash: 'faq',
    title: 'FAQ'
  },
];

const parser = new UAParser();
const ua = parser.getResult();
const downloadLink = ua.os.name === 'Android' ? 
    'http://play.google.com/store/apps/details?id=com.now.moov' :
    'https://itunes.apple.com/hk/app/moov-%E9%9F%B3%E6%A8%82%E9%9A%A8%E8%BA%AB-music-everywhere/id436310157?mt=8&ct=moov_intro_page';

const HeaderWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 72px;
  z-index: 20;

  @media only screen and (min-width: 800px) {
    padding-top: 38px;
  }
`;

const HeaderFixed = styled.div`
  position: fixed;
  transform: translate3d(0,0,0);
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;

  > a {
    display: inline-block;
    vertical-align: top;
    line-height: 1;
    width: 25%;
    text-align: center;
    background-color: #FFF;
    padding: 8px;
    box-sizing: border-box;
    text-decoration: none;
    color: black;
    white-space: nowrap;
  }
`;

const HeaderTop = styled.div`
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 8px;
  background-color: white;
`;

const HeaderNav = styled.div`
  background-color: black;

  a {
    position: relative;
    width: 25%;
    box-sizing: border-box;
    padding: 10px 0;
    display: inline-block;
    text-decoration: none;
    font-size: 13px;
    color: white;
    text-align: center;

    &.active {
      color: ${props => props.theme.colors.primary};
      font-weight: bold;
    }

    &:after {
      position: absolute;
      content: '|';
      font-weight: normal;
      right: -2px;
      color: ${props => props.theme.colors.primary};
    }

    &:last-child:after {
      display: none;
    }
  }
`;

const DesktopHeaderNav = styled(HeaderNav)`
  background-color: white;

  a {
    color: #000;
    font-size: 18px;
    width: calc(43vw / 4);
    padding: 8px;
    box-sizing: border-box;
    white-space: nowrap;

    &:first-child {
      width: 30vw;
      text-align: left;
    }

    &:last-child {
      width: 25vw;
      text-align: right;
    }

    &:nth-child(5):after,
    &:first-child:after {
      display: none;
    }


    @media only screen and (min-width: 1024px) and (max-width: 1200px) {
      width: calc(52vw / 4);
      &:last-child {
        width: 20vw;
        text-align: right;
      }

      &:first-child {
        width: 25vw;
        text-align: left;
      }
    }

    @media only screen and (min-width: 801px) and (max-width: 1023px) {
      width: calc(52vw / 4);
      &:last-child {
        width: 20vw;
        text-align: right;
      }

      &:first-child {
        width: 25vw;
        text-align: left;
      }
    }
  }
`;

const LogoLink = styled.a`
  position: relative;
  left: -14px;
  display: block;
`;

const StyledLogo = styled(Logo)`
  svg {
    width: 100px;
    fill: #000;
  }
`;

const StyledLink = styled(Link)`
  cursor: pointer;
`

const Header = ({ isRedirect }) => (
  <HeaderWrapper>
    <HeaderFixed>
      <div className="mobile" >
        <HeaderTop>
          <a href={process.env.REACT_APP_BASE_URL}>
            <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home.png`} alt="" width="18" />
          </a>
          <LogoLink href={downloadLink}><StyledLogo /></LogoLink>
          <div />
        </HeaderTop>
        <HeaderNav>
        {
          menuItems.map((item, index) => {
            let Element = null;
            if (!!isRedirect) {
              Element = <a key={index} href={`${process.env.REACT_APP_BASE_URL}#${item.hash}`}>{item.title}</a>;
            } else {
              Element = <Link
                          key={index}
                          to={item.hash}
                          smooth={true}
                          spy={true}
                          hashSpy={true}
                          offset={-76}
                        >
                          {item.title}
                        </Link>
            }

            return Element;
          })
        }
        </HeaderNav>
      </div>
      <div className="desktop">
        <DesktopHeaderNav>
          <a href={process.env.REACT_APP_BASE_URL}>
            <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home.png`} alt="" width="18" />
          </a>
          {
            menuItems.map((item, index) => {
              let Element = null;
              if (!!isRedirect) {
                Element = <a key={index} href={`${process.env.REACT_APP_BASE_URL}#${item.hash}`}>{item.title}</a>;
              } else {
                Element = <StyledLink
                            key={index}
                            to={item.hash}
                            smooth={true}
                            spy={true}
                            hashSpy={true}
                            offset={-38}
                          >
                            {item.title}
                          </StyledLink>
              }

              return Element;
            })
          }
          <a style={{ cursor: 'auto' }}>
            <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/moov_logo.png`} alt="" height="18" />
          </a>
        </DesktopHeaderNav>
      </div>
    </HeaderFixed>
  </HeaderWrapper>
);

export default Header;